<!-- Section Pompe -->
<app-collapse
  [title]="'P00058.parameters.status.rubrique.pompe' | translate"
  [warning]="getValue('pvSCodeErreur') !== 0"
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="
        'P00058.parameters.status.statut.courantConsommeParLaPompe' | translate
      "
      [value]="(getValue('pvSCourantConsomme') / 10).toFixed(1) + ' A'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00058.parameters.status.statut.vitesseReelle' | translate"
        [value]="getVitesse()"
      />
    }

    <app-display-rubrique-status
      [title]="'P00058.parameters.status.statut.puissance' | translate"
      [value]="getValue('pvSPuissanceDriver') + ' W'"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00058.parameters.status.statut.erreurPompe' | translate"
      [warning]="getValue('pvSCodeErreur') !== 0"
      icon=""
      text="--"
    />

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00058.parameters.status.statut.codeErreur' | translate"
      [warning]="false"
      [ctaText]="'P00058.parameters.status.statut.codeErreur.cta' | translate"
      [notWarning]="
        getValue('pvSCodeErreur') === 0
          ? '--'
          : getValue('pvSCodeErreur').toString(16).padStart(2, '0')
      "
      (onPress)="(onAssistancePress)"
    />

    <app-display-rubrique-status
      [title]="'P00058.parameters.status.statut.codeErreur' | translate"
      [value]="getValue('pvSCodeErreur').toString(16).padStart(2, '0')"
    />

    <app-display-rubrique-status
      [title]="'P00058.parameters.status.statut.amorcageEnCours' | translate"
      [value]="
        getValue('pvSAmorcageEnCours') === 0
          ? ('P00058.parameters.status.statut.amorcageEnCours.non' | translate)
          : ('P00058.parameters.status.statut.amorcageEnCours.oui' | translate)
      "
    />
  </div>
</app-collapse>

<!-- Section Programme 72H -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P00058.parameters.status.rubrique.programme72h' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pilotagePompeProg72' | translate
        "
        [value]="
          getValue('pvSCompteRebours72') === 0
            ? '--'
            : ('P00058.parameters.status.statut.pilotagePompeProg72.max'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pilotagePompeProg72timeLeft'
            | translate
        "
        [value]="
          getValue('pvSCompteRebours72') === 0
            ? '--'
            : convertSecondsToTime(getValue('pvSCompteRebours72'), true)
        "
      />
    </div>
  </app-collapse>
}

<!-- Section Programme Horloge -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="
      'P00058.parameters.status.rubrique.programmeHorlogeExpanded' | translate
    "
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pilotagePompeHorlogeHiver'
            | translate
        "
        [value]="getVitesse('pvSConsigneHorlogeHivers')"
      />

      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pilotagePompeHorlogeEte' | translate
        "
        [value]="getVitesse('pvSConsigneHorlogeEte')"
      />
    </div>
  </app-collapse>
}

<!-- Section Mode Ecremage -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P00058.parameters.status.rubrique.modeEcremage' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pilotagePompeModeEcremage'
            | translate
        "
        [value]="
          getValue('pvSCompteReboursEcremage') === 0
            ? '--'
            : getVitesse('pvPVitesseEcremage')
        "
      />

      <app-display-rubrique-status
        [title]="'P00058.parameters.status.statut.etatVolet' | translate"
        [value]="
          getValue('pvSEtatVolet') === 0
            ? ('P00058.parameters.status.statut.etatVolet.ouvert' | translate)
            : ('P00058.parameters.status.statut.etatVolet.ferme' | translate)
        "
      />
    </div>
  </app-collapse>
}

<!-- Section Programme Baignade -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P00058.parameters.status.rubrique.programmeBaignade' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pilotagePompeProgrammeBaignade'
            | translate
        "
        [value]="
          getValue('pvSCompteReboursBaignade') === 0
            ? '--'
            : getVitesse('pvPVitesseV2')
        "
      />
    </div>
  </app-collapse>
}

<!-- Section Fonction Hors Gel -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P00058.parameters.status.rubrique.fonctionHorsGel' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.temperatureRefHorsGelDisponible'
            | translate
        "
        [value]="
          getValue('pvSDisponibiliteTemperatureHorsGel') === 0
            ? ('P00058.parameters.status.statut.temperatureRefHorsGelDisponible.non'
              | translate)
            : ('P00058.parameters.status.statut.temperatureRefHorsGelDisponible.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00058.parameters.status.statut.consigneHorsGel' | translate"
        [value]="getVitesse('pvSConsigneHorsGel')"
      />

      <app-display-rubrique-status
        [title]="'P00058.parameters.status.statut.mesureHorsGel' | translate"
        [value]="
          getTemperature(getValue('pvSMesureTemperatureEauHorsGel') / 10)
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.etatfonctionHorsGel' | translate
        "
        [value]="getValue('pvSEtatFonctionHorsGel') === 0"
      />
    </div>
  </app-collapse>
}

<!-- Section Fonction 24/24 -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P00058.parameters.status.rubrique.fonction2424' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.temperatureRef2424Disponible'
            | translate
        "
        [value]="
          getValue('pvSDisponibiliteTemperature24') === 0
            ? ('P00058.parameters.status.statut.temperatureRef2424Disponible.non'
              | translate)
            : ('P00058.parameters.status.statut.temperatureRef2424Disponible.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00058.parameters.status.statut.consigne2424' | translate"
        [value]="getVitesse('pvSConsigne24')"
      />

      <app-display-rubrique-status
        [title]="'P00058.parameters.status.statut.mesure2424' | translate"
        [value]="getTemperature(getValue('pvSMesureTemperatureEau24') / 10)"
      />
    </div>
  </app-collapse>
}

<!-- Section Asservissements -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="
      'P00058.parameters.status.rubrique.asservissementsExpanded' | translate
    "
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pompeFiltrationAsservissement'
            | translate
        "
        [value]="
          getValue('pvSAvertissement') === 0
            ? ('P00058.parameters.status.statut.pompeFiltrationAsservissement.non'
              | translate)
            : ('P00058.parameters.status.statut.pompeFiltrationAsservissement.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.pompeFiltrationFonctionEntreeAsservi'
            | translate
        "
        [value]="getPompeFiltrationFonctionEntreeAsservi()"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsserviePrioriteElectrolyseElectrolyseurStandard'
            | translate
        "
        [value]="getValue('pvSEafPrioriteStandard') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieAutoMaintienFiltrationElectrolyseurStandard'
            | translate
        "
        [value]="getValue('pvSEafAutoMaintienElectrolyseurStandard') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionCL'
            | translate
        "
        [value]="getValue('pvSEafAutoMaintienInjectionCL') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P00058.parameters.status.statut.entreeAsserviePrioriteElectrolyseElectrolyseurCellule'
              | translate
          )
        "
        [value]="getValue('pvSEafPrioriteCellule') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P00058.parameters.status.statut.entreeAsservieBoostElectrolyseElectrolyseurCellule'
              | translate
          )
        "
        [value]="getValue('pvSEafPrioriteBoostCellule') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P00058.parameters.status.statut.entreeAsservieAutoMaintienFiltrationElectrolyseurCellule'
              | translate
          )
        "
        [value]="getValue('pvSEafAutoMaintienElectrolyseurCellule') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPH'
            | translate
        "
        [value]="getValue('pvSEafAutoMaintienInjectionPh') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPAC'
            | translate
        "
        [value]="getValue('pvSEafAutoMaintienPac') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPAC'
            | translate
        "
        [value]="getValue('pvSEafPrioritePac') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieAutomaintienFiltrationInjectionPACWp'
            | translate
        "
        [value]="getValue('pvSEafAutoMaintienPacWP') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPACWp'
            | translate
        "
        [value]="getValue('pvSEafPrioritePacWP') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieAutomaintienFiltrationInjectionPACPoly'
            | translate
        "
        [value]="getValue('pvSEafAutoMaintienPacPoly') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPACPoly'
            | translate
        "
        [value]="getValue('pvSEafPrioritePacPoly') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieRedemarrageEclairageStandard'
            | translate
        "
        [value]="getValue('pvSEafRedemEclairageStandard') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieRedemarrageEclairageTunable'
            | translate
        "
        [value]="getValue('pvSEafRedemEclairageTunalble') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsserviePrioriteRobot'
            | translate
        "
        [value]="getValue('pvSEafPrioriteRobot') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieAutoMaintienRobot'
            | translate
        "
        [value]="getValue('pvSEafAutoMaintientRobot') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieArretFiltrationVolet24'
            | translate
        "
        [value]="getValue('pvSEaaFiltrationVolet24') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P00058.parameters.status.statut.entreeAsservieArretFiltrationVolet230'
            | translate
        "
        [value]="getValue('pvSEaaFiltrationVolet230') !== 0"
      />
    </div>
  </app-collapse>
}

<!-- Section Produit -->
<app-collapse
  [title]="'P00058.parameters.status.rubrique.produitExpanded' | translate"
  [warning]="presenceProduit === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00058.parameters.status.statut.presenceDuProduit' | translate"
      [warning]="presenceProduit !== 1"
      icon=""
      [text]="
        'P00058.parameters.status.statut.presenceDuProduit.ok' | translate
      "
    />

    <app-display-rubrique-status
      [title]="'P00058.parameters.status.statut.tempsSousTension' | translate"
      [value]="transformHourToDayHourLocal(getValue('pvSTempsSousTension'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.compteurPuissanceActiveTotale'
            | translate
        "
        [value]="getValue('pvSCompteurPuissanceActive') + ' Wh'"
      />

      <app-display-rubrique-status
        [title]="
          'P00058.parameters.status.statut.compteurAmpereHeure' | translate
        "
        [value]="getValue('pvSCompteurAh') + ' Ah'"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00058.parameters.status.statut.etatDuBouton' | translate"
        [value]="getValue('pvSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P00058.parameters.status.statut.compteurDuBouton' | translate"
        [value]="getValue('pvSCompteurBouton') + ''"
      />
    }
  </div>
</app-collapse>
